import request from 'services/axios'

export const getSettlements = async (
    pageParam: number,
    moneyPool: string | undefined
) => {
    const { data }: { data: ISettlements } = await request.get(
        `/api/v1/moneypools/${moneyPool}/exit-request/?page=${pageParam}`
    )
    return data
}

export const DeleteMySettlement = async (payload: number) => {
    const response = await request.delete(
        `/api/v1/moneypools/${payload}/exit-request/`
    )
    return response
}
export const setSettlement = async (payload: ISetSettlementPayload) => {
    const { data } = await request.post(
        `/api/v1/moneypools/${payload.id}/exit-request/`,
        {
            ...payload,
        }
    )
    return data
}

export const getAdminSettlements = async (
    pageParam: number,
    moneyPool: string | undefined
) => {
    const { data }: { data: IAdminSettlements } = await request.get(
        `/api/v1/moneypools/${moneyPool}/admin-exit-request/?page=${pageParam}`
    )
    return data
}
/**
 * رد کردن درخواست تسویه و خروج.
 *
 * Reject and accept share one URL and differ only in the verb — the backend
 * routes `{'post': 'reject', 'put': 'accept'}` (moneypool_management/api/urls.py).
 * Until now the PWA only ever sent the POST, which is why «قبول» could not
 * work no matter what the screen did.
 */
export const rejectExitRequest = async (
    payload: getAdminSettlementsPostPayload
) => {
    const { data } = await request.post(
        `/api/v1/moneypools/${payload.moneyPool}/admin-exit-request/`,
        {
            exit_request_id: payload.id,
        }
    )
    return data
}

/**
 * پذیرش درخواست تسویه و خروج — the stamp on the request, and nothing else.
 *
 * It does not settle the account and does not remove the member; that is
 * `checkoutPoolship`, and it has to succeed first. Sending this on its own
 * would leave a member marked as «پذیرفته شده» while still in the fund with
 * their money in it.
 */
export const acceptExitRequest = async (
    payload: getAdminSettlementsPostPayload
) => {
    const { data } = await request.put(
        `/api/v1/moneypools/${payload.moneyPool}/admin-exit-request/`,
        {
            exit_request_id: payload.id,
        }
    )
    return data
}

/**
 * تسویهٔ حساب عضو و خروج او از صندوق.
 *
 * One call does all of it, inside one DB transaction: unpaid instalments are
 * settled, the remaining balance is paid out, the membership is deactivated.
 * With a `bankAccount` and a positive balance the money leaves «موجودی نزد
 * همیان» for that account; with nothing left to pay, the body is empty and
 * the call only closes the membership.
 *
 * NOTE: no trailing slash. The route is `.../checkout$` while its sibling
 * `checkout-status` has none — a trailing slash here is a 404.
 */
export const checkoutPoolship = async (payload: ICheckoutPoolshipPayload) => {
    const { data } = await request.post(
        `/api/v1/moneypools/${payload.moneyPool}/poolships/${payload.poolShip}/checkout`,
        payload.bankAccount ? { bank_account: payload.bankAccount } : {}
    )
    return data
}

/**
 * «فقط ثبت شود» — the manager pays the member themselves and the fund's books
 * record it.
 *
 * Registering the payout as a plain cash-out brings the member's balance to
 * zero, so the `checkoutPoolship` that follows has nothing left to pay and
 * closes the membership without touching «موجودی نزد همیان». This is the only
 * route out for a صندوق نگران or a صندوق ثبتی, where Hamyan never holds the
 * money in the first place.
 */
export const recordSettlementCashout = async (
    payload: IRecordSettlementCashoutPayload
) => {
    const { data } = await request.post(
        `/api/v1/payment/moneypools/${payload.moneyPool}/moneypool-cashouts/`,
        {
            poolship: payload.poolShip,
            amount: payload.amount,
            type: 'ctc',
            // «سرمایهٔ شخصی» — the member's own money going back to them,
            // not a fund expense (utils/constants/choice.py CASHOUT_*)
            reason: '0',
            tag: 'برداشت باقیمانده سرمایه عضو برای تسویه حساب',
        }
    )
    return data
}

export const getSettlementCheckStatus = async (
    payload: IGetSettlementCheckStatusPayload
) => {
    const { data }: { data: IGetSettlementCheckStatusResponse } =
        await request.get(
            `/api/v1/moneypools/${payload.moneyPool}/poolships/${payload.poolShip}/checkout-status/`
        )
    return data
}
